import React from 'react';
import ReactDOM from 'react-dom';
import TooieApp from '../react/TooieApp.react.js';
import _ from "underscore";
import Backbone from "backbone";
import pos from "../POS.js";
import DbRecorder from "../recorder/DbRecorder.js";
import PosView from "../PosView.js";
import BillRecorder from "../recorder/BillRecorder.js";
import FastClick from "fastclick";
import LicenseCheckView from "../view/LicenseCheckView.js";
import EnvMonitorView from "../view/EnvironmentMonitorView.js";
import i18next from "i18next";
import resBundle from "../locales/locales";
import $ from 'jquery';
import NetworkCheckView from '../view/NetworkCheckView.js';
import moment from 'moment';

console.log('resBundle', resBundle);

export default class BootstrapService {
    run() {
        console.time('pre-page-setup');
        this._onPrePageSetup();
        console.timeEnd('pre-page-setup');
        console.time('i18n-init');
        console.log('resBundle', resBundle);
        i18next.init({lng: "zh_CN", resources: resBundle}, () => {
            console.timeEnd('i18n-init');
            console.time('pos/index');
            const posData = $('#posData').val();

            if (posData) {
                const res = JSON.parse(posData);
                $('#posData').remove();
                window.TOOIE_INIT_PARAMS = res;
                moment.locale(res.locale.toString());
                ReactDOM.render(
                    <TooieApp {...res} />,
                    document.getElementById('reactApp'));
                this._onPageReady();

            } else {
                alert('数据加载问题, 请刷新页面');
            }

        });
    }

    _onPrePageSetup() {
        window.analytics = function (arg1, arg2, arg3, arg4, arg5) {
            if (typeof(window._hmt) != 'undefined') {
                window._hmt.push(['_trackEvent', arg3, arg4, arg5]);
            }
            if (typeof(window._paq) != 'undefined') {
                window._paq.push(['trackEvent', arg3, arg4, arg5]);
            }
        };

        (function (f, b) {
            if (!b.__SV) {
                var a, e, i, g;
                window.mixpanel = b;
                b._i = [];
                b.init = function (a, e, d) {
                    function f(b, h) {
                        var a = h.split(".");
                        2 == a.length && (b = b[a[0]], h = a[1]);
                        b[h] = function () {
                            b.push([h].concat(Array.prototype.slice.call(arguments, 0)))
                        }
                    }

                    var c = b;
                    "undefined" !== typeof d ? c = b[d] = [] : d = "mixpanel";
                    c.people = c.people || [];
                    c.toString = function (b) {
                        var a = "mixpanel";
                        "mixpanel" !== d && (a += "." + d);
                        b || (a += " (stub)");
                        return a
                    };
                    c.people.toString = function () {
                        return c.toString(1) + ".people (stub)"
                    };
                    i = "disable track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" ");
                    for (g = 0; g < i.length; g++) f(c, i[g]);
                    b._i.push([a, e, d])
                };
                b.__SV = 1.2;
                a = f.createElement("script");
                a.type = "text/javascript";
                a.async = !0;
                a.src = "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL ? MIXPANEL_CUSTOM_LIB_URL : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
                e = f.getElementsByTagName("script")[0];
                e.parentNode.insertBefore(a, e);
            }
        })(document, window.mixpanel || []);

        window._mp = function (action, props) {
            if (!action) {
                return;
            }

            if (!props) {
                props = {};
            }
            props.env = window.TOOIE_INIT_PARAMS.env;
            mixpanel.track(action, props);
            console.log('send action ' + action + " to mixpanel", props);
        }
    }


    _onPageReady() {
        const TOOIE = window.TOOIE_INIT_PARAMS;

        console.log(new Date() + " init params: ", TOOIE);
        window.intercomSettings = {
            app_id: "kbzie3xh",
            restaurant: TOOIE.restaurant.name,
            "experience_restaurant": TOOIE.isExpRest,
            "environment": TOOIE.env
        };
        if (!TOOIE.isExpRest) {
            window.intercomSettings = _.extend(window.intercomSettings, {
                name: TOOIE.user.fullname,
                user_id: TOOIE.user.login.username,
                email: TOOIE.user.email,
                created_at: moment(TOOIE.restaurant.registeredDate).unix(),
                "status": TOOIE.firstLogin ? '刚注册' : '老客户'
            });
        }
        if (!TOOIE.branded) {
            window.intercomSettings.widget = {
                activator: "#helpIcon"
            }
        }
        console.log(new Date() + " intercom settings", window.intercomSettings);
        // install intercom
        (function () {
            var w = window;
            var ic = w.Intercom;
            if (typeof ic === "function") {
                ic('reattach_activator');
                ic('update', intercomSettings);
            } else {
                var d = document;
                var i = function () {
                    i.c(arguments)
                };
                i.q = [];
                i.c = function (args) {
                    i.q.push(args)
                };
                w.Intercom = i;
                (function l() {
                    var s = d.createElement('script');
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = 'https://widget.intercom.io/widget/kbzie3xh';
                    var x = d.getElementsByTagName('script')[0];
                    x.parentNode.insertBefore(s, x);
                })();
            }
        })();
        $("body").addClass("agent-online").removeClass("agent-offline");


        $('body').addClass(TOOIE.locale).addClass("lang-" + TOOIE.language)
            .addClass(TOOIE.isExpRest ? "experienceRestaurantDialogTop" : "");

        var userAgent = navigator.userAgent.toString();
        var browserString = navigator.userAgent.toLowerCase();
        var runningAndroidEmbedded = browserString.indexOf("533.1") > 0;

        // if (browserString.indexOf('chrome') < 0 && browserString.indexOf('safari') < 0 && browserString.indexOf('firefox') < 0 && browserString.indexOf('msie 9.0') < 0 && browserString.indexOf('msie 10.0') < 0 && browserString.indexOf('rv:11.0') < 0 && browserString.indexOf('ipad') < 0 && !runningAndroidEmbedded) {
        //     if (navigator.standalone) {
        //         // launched from ios home screen, then ignore browser check.
        //     } else {
        //         if (browserString.indexOf('msie 8.0') >= 0) {
        //             analytics('send', 'event', 'UserBrowser', 'Browser-IE8', "${restaurant.name.encodeAsJavaScript()}");
        //         }
        //         window.location.href = "/pos/indexToRemindChangeBrowser";
        //     }
        // }

        // if (userAgent.indexOf("Android 2") > 0) {
        //     $("head").append("<link>");
        //     var cssFile = $("head").children(":last");
        //     cssFile.attr({
        //         rel: "stylesheet",
        //         type: "css",
        //         href: "/css/pos/supportPOS.less"
        //     });
        // }

        $("#needRefresh .alert-link").click(function (event) {
            var appId = DbRecorder.read("chromeAppId");
            var seenHelp = DbRecorder.read("seenHelp");
            var networkPrinterSetting = localStorage.getItem("networkPrinterSetting") ? JSON.parse(localStorage.getItem("networkPrinterSetting")) : [];
            localStorage.clear();
            DbRecorder.save("chromeAppId", appId);
            DbRecorder.save("seenHelp", seenHelp);
            localStorage.setItem("networkPrinterSetting", JSON.stringify(networkPrinterSetting));
            pos.makeHideConfirm();
            _.delay(function () {
                window.location.reload();
            }, 1000);
            return false;
        });

        $(document).on("keydown", function (event) {
            if (event.keyCode == 8) {
                var doPrevent = false;
                if (event.keyCode === 8) {
                    var d = event.srcElement || event.target;
                    if ((d.tagName.toUpperCase() === 'INPUT' && (d.type.toUpperCase().match(/(TEXT)|(PASSWORD)|(FILE)|(EMAIL)|(NUMBER)/)))
                        || d.tagName.toUpperCase() === 'TEXTAREA') {
                        doPrevent = d.readOnly || d.disabled;
                    }
                    else {
                        doPrevent = true;
                    }
                }
                if (doPrevent) {
                    try {
                        event.stopPropagation();
                    } catch (e) {
                        try {
                            event.preventDefault();
                        } catch (e) {

                        }
                    }
                    return false;
                }
            }
            return true;
        });

        window.onbeforeunload = function (event) {
            if (!DbRecorder.getStatus().online) {
                event.returnValue = i18next.t("pos.reload");
            }
        };

        FastClick.attach(document.body);

        var restaurant = DbRecorder.read('restaurant');
        if (restaurant && ((restaurant.name != TOOIE.restaurant.name) || (restaurant.version != TOOIE.restaurant.version))) {
            var networkPrinterSetting = localStorage.getItem("networkPrinterSetting") ? JSON.parse(localStorage.getItem("networkPrinterSetting")) : [];
            localStorage.clear();
            localStorage.setItem("networkPrinterSetting", JSON.stringify(networkPrinterSetting));
        }
        DbRecorder.save("restaurant", {
            id: TOOIE.restaurant.id,
            name: TOOIE.restaurant.name,
            version: TOOIE.restaurant.version
        });


        /*
         *  Actions to switch offline/online mode and clear session
         */
        var TooieOffline = false;
        $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
            if (TooieOffline) {
                options.url = "/nothing" + options.url;
            }
        });
        window.offline = function () {
            TooieOffline = true;
            console.log("Network status : " + DbRecorder.getStatus().online ? "online" : "offline");
        };
        window.online = function () {
            TooieOffline = false;
            console.log("Network status : " + DbRecorder.getStatus().online ? "online" : "offline");
        };
        window.clearSession = function () {
            $.post("/logout/ajax", {}, function (response) {
                console.log("logout", response);
            });
        };

        String.prototype.contains = function (c) {
            return this.indexOf(c) > -1;
        };

        this._setupMixpanel();

        if (TOOIE.env.indexOf('production') == 0) {
            // this._setupBaidu();
            // this._setupPiwiki();
        }

        const setupModel = new Backbone.Model({done: false, error: false});
        const networkCheckView = new NetworkCheckView({model: setupModel});
        return pos.setup()
            .then(this._initPosView.bind(this))
            .then(this._initBillRecorder.bind(this))
            .then(() => {
                setupModel.set({done: true});
                pos.showLoading(false);
            })
            .fail(() => {
                setupModel.set({error: true});
                alert(i18next.t("pos.error"));
                window.location.reload();
            });
    }

    _initPosView(response) {
        let MonitorView = new EnvMonitorView();
        MonitorView.init();
        //试用期用户到期前10，3，1天Pos提醒 ,非试用期用户到期前3，2，1天提醒
        if (response.licenseRemainsDays != localStorage.getItem("daysLeft") || localStorage.getItem("expireAlert") == undefined) {
            localStorage.setItem("expireAlert", "true");
        }
        localStorage.setItem("daysLeft", response.licenseRemainsDays);
        if (localStorage.getItem("expireAlert") == "true") {
            switch (response.licenseRemainsDays) {
                case 10:
                    if (response.attemptUserOrNot == "true") {
                        new LicenseCheckView({model: new Backbone.Model({licenseRemainsDays: response.licenseRemainsDays})}).render(response.licenseRemainsDays);
                        localStorage.setItem("expireAlert", "false");
                    }
                    break;
                case 3:
                    new LicenseCheckView({model: new Backbone.Model({licenseRemainsDays: response.licenseRemainsDays})}).render(response.licenseRemainsDays);
                    localStorage.setItem("expireAlert", "false");
                    break;
                case 2:
                    if (response.attemptUserOrNot == "false") {
                        new LicenseCheckView({model: new Backbone.Model({licenseRemainsDays: response.licenseRemainsDays})}).render(response.licenseRemainsDays);
                        localStorage.setItem("expireAlert", "false");
                    }
                    break;
                case 1:
                    new LicenseCheckView({model: new Backbone.Model({licenseRemainsDays: response.licenseRemainsDays})}).render(response.licenseRemainsDays);
                    localStorage.setItem("expireAlert", "false");
                    break;
                case 0:
                    new LicenseCheckView({model: new Backbone.Model({licenseRemainsDays: response.licenseRemainsDays})}).render(response.licenseRemainsDays);
                    break;
            }
        }
        (new PosView({el: $('body'), model: pos})).render();
        return $.Deferred().resolve();
    }

    _initBillRecorder() {
        const TOOIE = window.TOOIE_INIT_PARAMS;
        return BillRecorder.initialize(TOOIE.restaurant.pushChannelName);
    }

    _setupMixpanel() {
        const TOOIE = window.TOOIE_INIT_PARAMS;

        mixpanel.init("467ca97eba88f9d291f0f1edebcf5c8f");

        if (TOOIE.env.indexOf("production") != 0) {
            mixpanel.register({"$ignore": "true"});
        }

        if (TOOIE.isExpRest) {
            mixpanel.register_once({"已体验": "true"});
            _mp("进入体验餐厅");

        } else {
            const userName = TOOIE.user.fullname ? TOOIE.user.fullname : TOOIE.user.name;
            mixpanel.register_once({
                "已注册": "true",
                "餐厅名字": TOOIE.restaurant.name
            });
            mixpanel.people.set({
                "餐厅名字": TOOIE.restaurant.name,
                "注册日期": TOOIE.registeredDate,
                "$email": TOOIE.user.email,
                "$first_name": userName,
                "付费用户": TOOIE.isPayingCustomer ? "是" : "否",
                "服务器": TOOIE.env == "production" ? "中国" : (TOOIE.env == "production-en" ? "英国" : "其他")
            });

            if (TOOIE.justRegistered) {
                mixpanel.alias(TOOIE.user.login.username);
                mixpanel.track("完成注册");

            } else {
                mixpanel.identify(TOOIE.user.login.username);
                mixpanel.track("打开POS");
            }
        }
    }

    _setupBaidu() {
        console.log('setup baidu analytics');
        window._hmt = window._hmt || [];
        (function () {
            var hm = document.createElement("script");
            hm.src = "//hm.baidu.com/hm.js?fe05b1ee91b82ce839d941a673b64060";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
        })();
    }

    _setupPiwiki() {
        const TOOIE = window.TOOIE_INIT_PARAMS, env = TOOIE.env;
        console.log('setup piwiki');

        //only support uat 2 or production 3!
        const siteId = env == "uat" ? 2 : 3;

        window._paq = window._paq || [];
        var _paq = window._paq;
        if (TOOIE.restaurant) {
            _paq.push(['setUserId', TOOIE.restaurant.name]);
        } else if (TOOIE.user) {
            _paq.push(['setUserId', TOOIE.user.login.username]);
        }

        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function () {
            var u = (("https:" == document.location.protocol) ? "https" : "http") + "://piwik.tooieapp.com/piwik/";
            _paq.push(['setTrackerUrl', u + 'piwik.php']);
            _paq.push(['setSiteId', siteId]);
            var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
            g.type = 'text/javascript';
            g.defer = true;
            g.async = true;
            g.src = u + 'piwik.js';
            s.parentNode.insertBefore(g, s);
        })();
    }
};


// WEBPACK FOOTER //
// ./src/service/BootstrapService.js